import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-manage-role-qualifier',
  templateUrl: './manage-role-qualifier.component.html',
  styleUrls: ['./manage-role-qualifier.component.scss']
})
export class ManageRoleQualifierComponent implements OnInit {
  public manageUserRolesList:string [] = [];
  public globalUserTypeList:any=[];
  public globalUserTypeNegativeList:any=[];
  public globalMarketTypeList:any=[];
  public globalMarketTypeNegativeList:any=[];
  public countryList: any;
  public userTypeQualifier: string = '';
  public date = '';
  public countryCode: string = 'Please Select';
  public qualifierType:string=''
  public userRoles:any
  public disabled=true;
  public addResponse:any;
  public addUserResponse:any;
  public positiveResponseQualifier='';
  public negativeResponseQualifier=''
  public negativeResponseDate=''
  public positiveResponseDate=''
  public positiveUserResponseQualifier='';
  public negativeUserResponseQualifier=''
  public negativeUserResponseDate=''
  public positiveUserResponseDate=''
  public deleteResponse=""
  public isDeleteData=false;
  public isDeleteMarketPositive=false;
  public isDeleteMarketNegative=false;
  public isDeleteUserPositive=false;
  public isDeleteUserNegative=false;


  constructor(private modalService: NgbModal, public service: ApifirstService,public datePipe:DatePipe) { }
  changeDate(date: any, date1: any) {
    this.date = date;
  }


  ngOnInit(): void {
    this.getUserRoles();
    this.getCountryList();
  }
  openPopUp(longcontent: any) {
    this.modalService.open(longcontent, { centered: true });
  }
  openSecondPopUp(content: any) {
    this.modalService.open(content, { centered: true });
  }
openDeletePopUp(delContent:any,data:string){
  this.modalService.open(delContent,{centered:true})
  localStorage.setItem('data',data);
}
delepopup4(delContent:any,data:string){
  this.modalService.open(delContent,{centered:true})
  localStorage.setItem('data',data);
}
delepopup3(delContent:any,data:string){
  this.modalService.open(delContent,{centered:true})
  localStorage.setItem('data',data);
}
delepopup2(delContent:any,data:string){
  this.modalService.open(delContent,{centered:true})
  localStorage.setItem('data',data);
}

  getUserRoles() {
    this.service.getManageQualifierRoles().subscribe((data) => {
      this.manageUserRolesList = data
      this.userRoles=this.manageUserRolesList[0];
    })
  }
  add() {
    let newDate=this.datePipe.transform(this.date,'yyyy-MM-dd')
    let enabled=0
    if(this.qualifierType=='true'){
      enabled=1
    }else{
      enabled=0
      newDate='0'
    }
   const req= {
      "qualifierDiscriminator":"MARKET",
      "expires" : newDate,
      "enabled": enabled,
      "qualifier": this.userTypeQualifier,
      "roleName" : this.userRoles
      }
    this.service.addForMngQualifier(req).subscribe(
      (data1) => {
        this.addResponse=data1;
         if(this.addResponse.enabled==1){
          this.globalMarketTypeList.push(this.addResponse);
        }
        else{
             this.globalMarketTypeNegativeList.push(this.addResponse);
        }
      })
  }

  getCountryList() {

    this.service.getCountryDetails().subscribe(
      (data1) => {
        this.countryList = data1
      })
  }
  positive(sel:any){
    console.log(sel.target.value,"sel")
    if(sel.target.value=="true"){
      this.disabled=false;
    }
    else if(sel.target.value=="false"){
      this.disabled=true;
      this.date='';
    }
    
  }
  deleteData(value:string){
    let data =localStorage.getItem('data');
    if(value=='1'){
      this.globalUserTypeList = this.globalUserTypeList.filter((item:any) => item.qualifier !== data);
    }else if(value=='2'){
      this.globalMarketTypeNegativeList = this.globalMarketTypeNegativeList.filter((item:any) => item.qualifier !== data);   
    }
    else if(value=='3'){    
      this.globalUserTypeNegativeList = this.globalUserTypeNegativeList.filter((item:any) => item.qualifier !== data);   
    }
    else if(value=='4'){
      this.globalMarketTypeList = this.globalMarketTypeList.filter((item:any) => item.qualifier !== data);
    }
    this.addResponse=null;
    this.service.deleteForMngQualifier().subscribe(
      (data1) => {
        this.deleteResponse = data1
      })
  }

  addUser() {
    let newDate=this.datePipe.transform(this.date,'yyyy-MM-dd')
    let enabled=0;
    if(this.qualifierType=='true'){
      enabled=1;
    }
    else{
      enabled=0;
      newDate='0'
    }
   const req= {
      "qualifierDiscriminator":"USERTYPE",
      "expires" : newDate,
      "enabled": enabled,
      "qualifier": this.userTypeQualifier,
      "roleName" : this.userRoles
      }
    this.service.addForMngQualifier(req).subscribe(
      (data1) => {
        this.addUserResponse=data1
        if(this.addUserResponse.enabled==1){
          this.globalUserTypeList.push(this.addUserResponse);
        }
        else{
             this.globalUserTypeNegativeList.push(this.addUserResponse);
            
        }
      })
  }
}
